export default __webpack_public_path__ + "static/media/who-we-are-image-4.f195f9dc.jpg";